import consumer from "./consumer"

// Subscribes to live candle updates for one pair + timeframe.
// `onUpdate` receives the full payload: { candles, indicators }.
// Returns the subscription; call `.unsubscribe()` to stop.
export function subscribeToCandles({ pairId, timeframe, onUpdate }) {
  return consumer.subscriptions.create(
    { channel: "CandlesChannel", trading_pair_id: pairId, timeframe },
    {
      received(data) {
        if (data && data.candles) onUpdate(data)
      }
    }
  )
}
